"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientWaiver = void 0;
const barcode_1 = require("client/components/barcode");
const store_1 = require("client/modules/orders/store");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const react_1 = require("react");
const React = require("react");
require("./patient-waiver.less");
const isPrinting = window.location.href.includes("print-labels");
let PatientWaiver = class PatientWaiver extends react_1.Component {
    constructor(props) {
        super(props);
        this.renderHeader = (inventory, patient) => (React.createElement("tr", null,
            React.createElement("td", { className: "patient-waiver__header" },
                React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", { className: "patient-waiver__info" },
                                React.createElement("span", { className: "patient-waiver__name" },
                                    patient.lastName,
                                    ", ",
                                    patient.firstName),
                                React.createElement("br", null),
                                [patient.address, patient.address2].join("").trim(),
                                ",",
                                " ",
                                patient.city,
                                " ",
                                patient.state,
                                " ",
                                patient.zip,
                                React.createElement("br", null),
                                "DOB: ",
                                moment(patient.birthDate).format("MM/DD/YYYY"),
                                " ",
                                "\u00A0\u00A0",
                                patient.gender === "1" ? "Male" : "Female"),
                            isPrinting && (React.createElement("td", null,
                                React.createElement(barcode_1.UiBarcode, { background: "transparent", displayValue: true, height: 80, lineColor: "#26324e", value: inventory.barCode, margin: 0, marginLeft: 20, width: 1 })))))))));
        this.renderTitle = () => (React.createElement("tr", null,
            React.createElement("td", { className: "patient-waiver__title-container" },
                React.createElement("br", null),
                React.createElement("span", { className: "patient-waiver__title" }, "Patient Medication Waiver"))));
        this.renderBody = (orderSite) => (React.createElement("tr", null,
            React.createElement("td", null,
                "In keeping with our mission to deliver quality, convenient, patient-centered care, ",
                orderSite.name,
                " offers its patients in-office dispensing of select medications. Doing so will better ensure you receive your medication as quickly and cost-effectively as possible so treatment can start right away.",
                React.createElement("br", null),
                React.createElement("br", null),
                "You have the right to fill your medication at any pharmacy of your choosing. If you decide to fill your prescription at another pharmacy, your decision will in no way affect the medical care you receive from our health care professionals.",
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("b", null,
                    "I hereby acknowledge reading and understanding the above information provided for the in-office dispensing program and have been given to opportunity to ask questions and wish to obtain my prescription from",
                    ` ${orderSite.name}`,
                    "."))));
        this.renderSignature = (claim) => isPrinting && (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("div", { className: "patient-waiver__signature" },
                    React.createElement("div", { className: "patient-waiver__signature-label" },
                        "Patient Signature: \u00A0",
                        " "),
                    React.createElement("div", { className: "sig-pad" },
                        React.createElement("img", { src: claim.signature, className: "signature" }),
                        React.createElement("div", { className: "sig-pad__baseline" })),
                    React.createElement("div", { className: "patient-waiver__signature-label" }, "Date: \u00A0 "),
                    React.createElement("div", { className: "date-pad" },
                        React.createElement("div", { className: "date-pad__baseline" }))))));
    }
    render() {
        const claim = store_1.ordersStore.claim.value;
        const inventory = claim && claim.inventory;
        const patient = claim && claim.order.patient;
        const orderSite = claim && claim.order.site;
        return (React.createElement("div", { className: "patient-waiver" },
            React.createElement("table", null,
                React.createElement("tbody", null,
                    inventory && patient && this.renderHeader(inventory, patient),
                    this.renderTitle(),
                    orderSite && this.renderBody(orderSite),
                    claim && this.renderSignature(claim)))));
    }
};
PatientWaiver = __decorate([
    mobx_react_1.observer
], PatientWaiver);
exports.PatientWaiver = PatientWaiver;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/patient-waiver/patient-waiver.tsx
// module id = 2985
// module chunks = 0 1